const transformMap = {
  "loading4": "c1 || roleName",

  "part1_1":"c1 || roleName",
  "part1_2":["c2", "c3"],
  "part1_3": ["c4.full"],
  "part1_4":"",
  "part1_5":"c6",
  "part1_6":"c5",
  "part1_7":"",

  "part2_1":["c7.normal", "c7.special"],
  "part2_2":"c7.friend",
  "part2_3":"c8",
  "part2_4": ["'SSR:'","c9.ssr", "'SR:'","c9.sr", "'R:'","c9.r"],
  "part2_5":"",
  
  "part3_1": "c10",
  "part3_2":["c11.name", "c11.num", "c12"],
  "part3_3":["c14.min", "c14.second", "c14.mill"],
  "part3_4":["c15.min", "c15.second", "c15.mill"],
  "part3_5":"c13",
  "part3_6":"",

  "part4_1":"c16",
  "part4_2":["c17.name", "c17.num"],
  "part4_3":["c18"],
  "part4_4":"c19",
  "part4_5":"",
  "part4_6":["c20", "c21"],
  "part4_7":"",
  "part4_8":"",

  "part5_1":"c22",
  "part5_2":["c23.hundred", "c23.half"],
  "part5_3":"c24",
  "part5_4":"c25",
  "part5_5":"",
  "part5_6":"",
  
  "part6_1":"",
  "part6_2": ["c26", "c27"],
  "part6_3": ["c29", "c28", "c30", "c31"],
  "part6_4": ["c32"],
  "part6_5":"",

  "share1_1": "c1 || roleName",
  "share1_2": ["c2", "c3"],
  "share1_3": ["c4.full"],
  "share1_4": "",
  "share1_5": "c6",
  "share1_6": "c5",

  "share2_1":  ["c7.normal", "c7.special"],
  "share2_2": "c7.friend",
  "share2_3": "c8",
  "share2_4": ["'SSR:'","c9.ssr", "'SR:'","c9.sr", "'R:'","c9.r"],
  "share2_5": "",

  "share3_1": "c10",
  "share3_2": ["c11.name", "c11.num", "c12"],
  "share3_3": ["c14.min", "c14.second", "c14.mill"],
  "share3_4": ["c15.min", "c15.second", "c15.mill"],
  "share3_5": "c13",

  "share4_1": "c16",
  "share4_2": ["c17.name", "c17.num"],
  "share4_3":["c18"],
  "share4_4": "c19",
  "share4_5": "",
  "share4_6": ["c20", "c21"],

  "share5_1":  "c22",
  "share5_2": ["c23.hundred", "c23.half"],
  "share5_3": "c24",
  "share5_4": "c25",

  "share6_1": "",
  "share6_2": ["c26", "c27"],
  "share6_3": ["c29", "c28", "c30", "c31"],
  "share6_4": ["c32"],
  "share6_5": "",

  "longText1_1": "c1 || roleName",
  "longText1_2": ["c2", "c3"],
  "longText1_3": ["c4.full"],
  "longText1_4": "",
  "longText1_5": "c6",
  "longText1_6": "c5",

  "longText2_1":  ["c7.normal", "c7.special"],
  "longText2_2": "c7.friend",
  "longText2_3": "c8",
  "longText2_4": ["'SSR:'","c9.ssr", "'SR:'","c9.sr", "'R:'","c9.r"],
  
  "longText3_1": "c10",
  "longText3_2": ["c11.name", "c11.num", "c12"],
  "longText3_3": ["c14.min", "c14.second", "c14.mill"],
  "longText3_4": ["c15.min", "c15.second", "c15.mill"],
  "longText3_5": "c13",

  "longText4_1": "c16",
  "longText4_2": ["c17.name", "c17.num"],
  "longText4_3": ["c18"],
  "longText4_4": "c19",
  "longText4_5": "",
  "longText4_6": ["c20", "c21"],

  "longText5_1": "c22",
  "longText5_2": ["c23.hundred", "c23.half"],
  "longText5_3": "c24",
  "longText5_4": "c25",

  "longText6_1": "",
  "longText6_2": ["c26", "c27"],
  "longText6_3": ["c29", "c28", "c30", "c31"],
  "longText6_4": ["c32"],
  "longText6_5": "",

}
export default transformMap;